document.addEventListener("DOMContentLoaded", function() {
    let addToCartButton = document.querySelector(".product-form__submit");

    if (addToCartButton) {
        addToCartButton.addEventListener("click", function() {
            this.style.animation = "shake 0.5s ease-in-out"; // Áp dụng hiệu ứng rung
            setTimeout(() => {
                this.style.animation = ""; // Xóa hiệu ứng sau 0.5s
            }, 500);
        });
    }
});

// Tạo hiệu ứng rung (shake)
const style = document.createElement("style");
style.innerHTML = `
@keyframes shake {
    0% { transform: translateX(0); }
    25% { transform: translateX(-5px); }
    50% { transform: translateX(5px); }
    75% { transform: translateX(-5px); }
    100% { transform: translateX(0); }
}`;
document.head.appendChild(style);
